// This icon file is generated automatically.
var PEyeOutlined = { "icon": { "tag": "svg", "attrs": { "viewBox": "0 0 14 14", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M13.72 6.6C12.24 3.48 10 1.9 7 1.9 4 1.9 1.76 3.49.28 6.6a.94.94 0 000 .8C1.76 10.52 4 12.1 7 12.1c3 0 5.24-1.58 6.72-4.7a.94.94 0 000-.8zM7 10.97c-2.52 0-4.37-1.28-5.67-3.97C2.63 4.3 4.48 3.03 7 3.03S11.37 4.31 12.67 7c-1.3 2.7-3.15 3.97-5.67 3.97zm-.06-6.72a2.75 2.75 0 100 5.5 2.75 2.75 0 000-5.5zm0 4.5a1.75 1.75 0 110-3.5 1.75 1.75 0 010 3.5z", "fill-rule": "nonzero" } }] }, "name": "p-eye", "theme": "outlined" };
export default PEyeOutlined;



//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons-svg/es/asn/PEyeOutlined.js
// module id = 3375
// module chunks = 0